import { FETCH_PROFILE } from './types';
import { profile } from '../services/authService';

export const fetchProfile = () => async (dispatch) => {
  try {
    const { data } = await profile();
    const { user: { token }, location } = data;
    const currentUser = Object.assign({}, token, { locations: location });
    dispatch({ type: FETCH_PROFILE, payload: currentUser });
  } catch (e) {
    dispatch({ type: FETCH_PROFILE, payload: {} });
  }
};

export default fetchProfile;
